import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Taxiserviceinlohegaon() {



const cardData = {
  keyword: " Taxi Service in Lohegaon",

"headingDescription": "SRS Cab Service offers Taxi Service in Lohegaon, providing reliable, comfortable, and affordable transportation for airport transfers, daily commuting, and local travel. Our well-maintained vehicles, professional drivers, and timely pickups ensure a smooth and hassle-free journey across Lohegaon and Pune city. Ideal for airport drops, pickups, business travel, and outstation trips, SRS Cab Service delivers flexible booking options, transparent pricing, and 24/7 customer support for a convenient and stress-free travel experience.",
"topPlaces": [
  {
    "title": "Pune Airport",
    "description": "Pune Airport in Lohegaon is one of the busiest travel hubs in the city. Travelers using Taxi Service in Lohegaon from SRS Cab Service often rely on timely pickups and drops for domestic and international flights."
  },
  {
    "title": "Phoenix Marketcity",
    "description": "Phoenix Marketcity is a major shopping and entertainment destination near Lohegaon. Visitors using SRS Cab Service often visit for shopping, dining, and movies."
  },
  {
    "title": "Viman Nagar",
    "description": "Viman Nagar is a popular residential and commercial area near Lohegaon. Travelers using SRS Cab Service often commute here for business meetings and leisure activities."
  },
  {
    "title": "Aga Khan Palace",
    "description": "Aga Khan Palace is a historic landmark located near Lohegaon. Visitors using SRS Cab Service often explore its gardens and museum exhibits."
  },
  {
    "title": "Jogger’s Park Viman Nagar",
    "description": "Jogger’s Park is a peaceful green space ideal for walking and relaxation. Travelers using SRS Cab Service often visit this park for morning and evening leisure time."
  },
  {
    "title": "Symbiosis International University",
    "description": "Symbiosis International University is a well-known educational institution near Lohegaon. Visitors using SRS Cab Service often travel here for academic and official purposes."
  },
  {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description": "Dagdusheth Halwai Ganpati Temple is a famous religious site in Pune. Travelers using SRS Cab Service often visit to seek blessings and experience spiritual serenity."
  },
  {
    "title": "Shaniwar Wada",
    "description": "Shaniwar Wada is a historic fort located in Pune city. Visitors using SRS Cab Service often explore this landmark to learn about Pune’s heritage."
  },
  {
    "title": "Koregaon Park",
    "description": "Koregaon Park is a vibrant area known for cafes and nightlife. Travelers using SRS Cab Service often visit for dining and entertainment."
  },
  {
    "title": "Bund Garden",
    "description": "Bund Garden is a scenic spot near the Mula-Mutha River. Visitors using SRS Cab Service often relax here and enjoy the greenery."
  }
],



services: [
{
name: "Lohegaon Taxi Service",
description: "Lohegaon taxi service offers reliable transportation for local and airport travel. Customers can book taxis for daily and outstation trips. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with taxi services in Lohegaon."
},
{
name: "Taxi Booking Lohegaon",
description: "Taxi booking Lohegaon provides quick and easy reservation options. Customers can book taxis online or via phone. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Book your taxi easily in Lohegaon."
},
{
name: "Taxi in Lohegaon",
description: "Taxi in Lohegaon offers convenient travel for local and airport trips. Customers can book taxis for flexible journeys. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with taxi services in Lohegaon."
},
{
name: "Cab Service Lohegaon",
description: "Cab service Lohegaon provides dependable transportation for city and outstation travel. Customers can book cabs for business and personal trips. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with cab services."
},
{
name: "Lohegaon Cab Booking",
description: "Lohegaon cab booking offers quick reservation options for travelers. Customers can book cabs online or offline. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Book your cab easily in Lohegaon."
},
{
name: "Reliable Taxi Lohegaon",
description: "Reliable taxi Lohegaon provides trusted transportation for all travel needs. Customers can book dependable taxi services for safe journeys. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with reliable taxi services."
},
{
name: "Affordable Taxi Lohegaon",
description: "Affordable taxi Lohegaon offers budget-friendly travel for daily and airport trips. Customers can book taxis at competitive prices. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Transparent pricing ensures affordability. Travel easily with affordable taxi services."
},
{
name: "24/7 Taxi Service Lohegaon",
description: "24/7 taxi service Lohegaon provides round-the-clock transportation for customers. Travelers can book taxis anytime for urgent needs. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with 24/7 taxi services."
},
{
name: "Airport Taxi Lohegaon",
description: "Airport taxi Lohegaon offers reliable transfer services to and from Pune Airport. Customers can book taxis for timely pickups and drops. Professional drivers ensure punctual journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with airport taxi services."
},
{
name: "Luxury Taxi Lohegaon",
description: "Luxury taxi Lohegaon provides premium travel experience for customers. Users can enjoy high-end vehicles with extra comfort. Professional drivers ensure safe journeys. Spacious seating enhances experience. Flexible booking options are available. Travel comfortably with luxury taxi services."
},
{
name: "Taxi Near Lohegaon",
description: "Taxi near Lohegaon offers nearby booking options for quick travel. Customers can find taxis easily for instant rides. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Book taxis easily near Lohegaon."
},
{
name: "Cheapest Taxi Service in Lohegaon",
description: "Cheapest taxi service in Lohegaon provides low-cost travel solutions for customers. Users can book budget-friendly taxis for daily and airport trips. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Transparent pricing ensures affordability. Travel easily with cheap taxi services."
},
{
name: "Pune Airport to Shirdi Cab",
description: "Pune airport to Shirdi cab offers convenient travel for temple visits. Customers can book cabs for direct airport pickup and drop. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily from airport to Shirdi."
},
{
name: "Pune Airport Cab Service",
description: "Pune airport cab service provides reliable transportation for airport transfers. Customers can book taxis for pickup and drop services. Professional drivers ensure punctual journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with airport cab services."
},
{
name: "Lohegaon Pune Airport Cab Service",
description: "Lohegaon Pune airport cab service offers quick airport transfer solutions. Customers can book taxis for timely travel. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with airport cab services."
},
{
name: "Taxi Service in Lohegaon Airport",
description: "Taxi service in Lohegaon airport provides convenient transportation for travelers. Customers can book taxis for airport pickups and drops. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with airport taxi services."
},
{
name: "Pune Airport Pickup Point Cab",
description: "Pune airport pickup point cab offers easy pickup services from designated points. Customers can book taxis for hassle-free airport travel. Professional drivers ensure punctual pickups. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with pickup cab services."
},
{
name: "Pune Airport to Lonavala Cab",
description: "Pune airport to Lonavala cab provides comfortable travel for hill station trips. Customers can book cabs for scenic journeys. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with cab services."
},
{
name: "Pune Airport to Nashik Cab",
description: "Pune airport to Nashik cab offers reliable transportation for long-distance travel. Customers can book cabs for business and leisure trips. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with cab services."
},
{
name: "Pune Airport to Shirdi Cab Fare",
description: "Pune airport to Shirdi cab fare provides detailed pricing for travel planning. Customers can compare fares before booking rides. Affordable pricing ensures cost-effective travel. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Travel easily with cab fare services."
},
{
name: "Pune Airport to Kolhapur Cab",
description: "Pune airport to Kolhapur cab offers convenient long-distance travel for passengers. Customers can book cabs for direct journeys. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with cab services."
},
{
name: "Pune Airport to Aurangabad Cab",
description: "Pune airport to Aurangabad cab provides reliable intercity travel for customers. Users can book cabs for flexible journeys. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with cab services."
},
{
name: "Pune Airport to Shirdi One Way Cab",
description: "Pune airport to Shirdi one way cab offers economical travel without return charges. Customers can book direct rides easily. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Transparent pricing ensures affordability. Travel easily with one way cab services."
},
{
name: "Cab Service in Lohegaon",
description: "Cab service in Lohegaon provides convenient transportation for city and airport travel. Customers can book cabs for flexible journeys. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with cab services."
},
{
name: "Best Taxi Service in Lohegaon",
description: "Best taxi service in Lohegaon offers top-rated transportation for customers. Travelers can enjoy high-quality service and comfort. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with best taxi services."
},
{
name: "Cheap Taxi Service Lohegaon",
description: "Cheap taxi service Lohegaon provides budget-friendly transportation for daily and airport travel. Customers can book cabs at low prices. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Transparent pricing ensures affordability. Travel easily with cheap taxi services."
}
],

tableData: [
["Lohegaon Taxi Service","Taxi Booking Lohegaon"],
["Taxi in Lohegaon","Cab Service Lohegaon"],
["Lohegaon Cab Booking","Reliable Taxi Lohegaon"],
["Affordable Taxi Lohegaon","24/7 Taxi Service Lohegaon"],
["Airport Taxi Lohegaon","Luxury Taxi Lohegaon"],
["Taxi Near Lohegaon","Cheapest Taxi Service in Lohegaon"],
["Pune Airport to Shirdi Cab","Pune Airport Cab Service"],
["Lohegaon Pune Airport Cab Service","Taxi Service in Lohegaon Airport"],
["Pune Airport Pickup Point Cab","Pune Airport to Lonavala Cab"],
["Pune Airport to Nashik Cab","Pune Airport to Shirdi Cab Fare"],
["Pune Airport to Kolhapur Cab","Pune Airport to Aurangabad Cab"],
["Pune Airport to Shirdi One Way Cab","Cab Service in Lohegaon"],
["Best Taxi Service in Lohegaon","Cheap Taxi Service Lohegaon"]
],



whychoose: [
  {
    WhyChooseheading: "Airport Area Expertise in Lohegaon",
    WhyChoosedescription: "SRS Cab Service provides reliable taxi service in Lohegaon with drivers familiar with Pune Airport routes, ensuring quick pickups and smooth travel."
  },
  {
    WhyChooseheading: "Affordable Taxi Service in Lohegaon",
    WhyChoosedescription: "We offer budget-friendly taxi services in Lohegaon with transparent pricing. Customers get clear fare details without any hidden charges."
  },
  {
    WhyChooseheading: "24/7 Taxi Availability",
    WhyChoosedescription: "SRS Cab Service operates 24/7 in Lohegaon, making it convenient for airport transfers, daily travel, and emergency bookings anytime."
  },
  {
    WhyChooseheading: "Comfortable & AC Vehicles",
    WhyChoosedescription: "Our fleet includes clean, well-maintained, and air-conditioned vehicles to ensure a comfortable ride within Lohegaon and across Pune."
  },
  {
    WhyChooseheading: "Multiple Cab Options",
    WhyChoosedescription: "Choose from hatchbacks, sedans, SUVs like Ertiga and Innova, premium Innova Crysta, and Tempo Travellers for local and outstation travel."
  },
  {
    WhyChooseheading: "Fast Airport Pickup & Drop",
    WhyChoosedescription: "We provide quick pickup and drop services to Pune Airport from Lohegaon, making travel hassle-free for frequent flyers."
  },
  {
    WhyChooseheading: "Safe & Professional Drivers",
    WhyChoosedescription: "Our drivers are trained, experienced, and ensure safe driving with polite behavior and reliable service."
  },
  {
    WhyChooseheading: "Trusted Taxi Service in Lohegaon Pune",
    WhyChoosedescription: "SRS Cab Service is trusted for taxi service in Lohegaon due to punctual service, clean vehicles, and excellent customer experience."
  }
]
}

const faqData = [
  { question: "Do you provide taxi service in Lohegaon?", answer: "Yes, SRS Cab Service offers reliable taxi services in Lohegaon for local and outstation travel." },
  { question: "Is taxi service available in Lohegaon 24 hours?", answer: "Yes, our taxi service operates 24/7 for all travel needs." },
  { question: "Do you provide Pune Airport taxi from Lohegaon?", answer: "Yes, we provide fast airport pickup and drop services from Lohegaon." },
  { question: "Which areas do you cover near Lohegaon?", answer: "We cover Viman Nagar, Dhanori, Wagholi, Kharadi, and nearby areas." },
  { question: "Which vehicles are available?", answer: "We offer hatchbacks, sedans, SUVs, Innova Crysta, and Tempo Travellers." },
  { question: "Can I book taxi online in Lohegaon?", answer: "Yes, you can easily book taxi service online or via phone." },
  { question: "Do you provide one-way cab service?", answer: "Yes, we provide one-way and round-trip cab services from Lohegaon." },
  { question: "Are drivers professional?", answer: "Yes, all drivers are trained, experienced, and professional." },
  { question: "Are vehicles air-conditioned?", answer: "Yes, all vehicles are fully air-conditioned for comfortable travel." },
  { question: "Are vehicles cleaned regularly?", answer: "Yes, all vehicles are regularly cleaned and sanitized for safety." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Rohit Patil",
    feedback:
      "Booked taxi from Lohegaon to Pune Airport. Very quick and reliable service.",
    rating: 5
  },
  {
    id: 2,
    name: "Ms. Sneha Kulkarni",
    feedback:
      "Best taxi service in Lohegaon. Clean car, on-time pickup, and professional driver.",
    rating: 5
  }
];




























const Images = [
{ place: "/images/keyword/1.jpg", text: "Pune Cab Service", link: "Pune-Cab-Service" },
{ place: "/images/keyword/2.jpg", text: "Pune Taxi Hire", link: "Pune-Taxi-Hire" },
{ place: "/images/keyword/3.jpg", text: "Pune Online Cabs Booking", link: "Pune-Online-Cabs-Booking" },
{ place: "/images/keyword/4.jpg", text: "Best Cabs Service in Pune", link: "Best-Cabs-Service-in-Pune" },
{ place: "/images/keyword/5.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
{ place: "/images/keyword/6.jpg", text: "Pune to Nasik Cabs", link: "Pune-to-Nasik-Cabs" },
{ place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cab", link: "Pune-to-Mahabaleshwar-Cab" },
{ place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cab", link: "Pune-to-Lonavala-Cab" },
{ place: "/images/keyword/9.jpg", text: "Pune to Trimbakeshwar Cab", link: "Pune-to-Trimbakeshwar-Cab" },
{ place: "/images/keyword/10.jpg", text: "Pune to Shirdi Cab", link: "Pune-to-Shirdi-Cab" },
{ place: "/images/keyword/11.jpg", text: "Pune to Bhimashankar Cab", link: "Pune-to-Bhimashankar-Cab" },
{ place: "/images/keyword/12.jpg", text: "Pune to Indore Cabs", link: "Pune-to-Indore-Cabs" },
{ place: "/images/keyword/13.jpg", text: "Pune to Konkan Darshan Cab", link: "Pune-to-Konkan-Darshan-Cab" },
{ place: "/images/keyword/14.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
{ place: "/images/keyword/15.jpg", text: "Pune Outstation Cabs", link: "Pune-Outstation-Cabs" },
{ place: "/images/keyword/16.jpg", text: "Pune to Panchgani Cab", link: "Pune-to-Panchgani-Cab" },
{ place: "/images/keyword/17.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
{ place: "/images/keyword/18.jpg", text: "Ashtavinayak Darshan Cab", link: "Ashtavinayak-Darshan-Cab" },
{ place: "/images/keyword/19.jpg", text: "Pune to Nagpur Cab", link: "Pune-to-Nagpur-Cab" },
{ place: "/images/keyword/20.jpg", text: "Pune to Goa Cab", link: "Pune-to-Goa-Cab" },
{ place: "/images/keyword/21.jpg", text: "Pune to Ajanta Ellora Cab", link: "Pune-to-Ajanta-Ellora-Cab" },
{ place: "/images/keyword/22.jpg", text: "Pune to Satara Cabs", link: "Pune-to-Satara-Cabs" },
{ place: "/images/keyword/23.jpg", text: "Pune Airport Cabs", link: "Pune-Airport-Cabs" },
{ place: "/images/keyword/24.jpg", text: "Pune to Ayodhya Tour Package", link: "Pune-to-Ayodhya-Tour-Package" },
{ place: "/images/keyword/25.jpg", text: "Corporate Cab Service in Pune", link: "Corporate-Cab-Service-in-Pune" },
];











const jsonData = {
  "@context": "https://schema.org",
  "@type": "LocalBusiness",
  "name": "SRS Cab - Lohegaon Taxi Service",
  "description": "Reliable taxi service in Lohegaon, Pune with SRS Cab. Book affordable cabs for local travel, airport transfers, and outstation trips. 24/7 service with luxury, sedan, and tempo traveller options.",
  "image": "https://www.srscabservice.com/logo.png",
  "telephone": "+91 9011955415",
  "address": {
    "@type": "PostalAddress",
    "streetAddress": "Lohegaon",
    "addressLocality": "Pune",
    "addressRegion": "Maharashtra",
    "postalCode": "411014",
    "addressCountry": "IN"
  },
  "geo": {
    "@type": "GeoCoordinates",
    "latitude": "18.5821",
    "longitude": "73.9190"
  },
  "url": "https://www.srscabservice.com/lohegaon-taxi-service",
  "priceRange": "₹₹",
  "openingHours": "Mo-Su 00:00-23:59",
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "bestRating": "5",
    "worstRating": "1",
    "ratingCount": "1530"
  },
  "areaServed": {
    "@type": "City",
    "name": "Lohegaon, Pune"
  }
};







  return (
    <div>
      
<Helmet>
  <title>Taxi Service in Lohegaon | Call +91 9011955415 | SRS Cab</title>
  <meta 
    name="description" 
    content="Book reliable and affordable taxi service in Lohegaon, Pune with SRS Cab. Local rides, airport transfers, and outstation cabs available 24/7. Luxury, sedan, and tempo traveller options." 
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>



 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/49.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#030706', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Srs Cab Service: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2 d-flex">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
               <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Srs Cab Service</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Srs Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                        //   title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919011955415" className="pc-call">+91 9011955415</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919011955415"
          target="_blank"
          rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp"></i> WhatsApp
        </a>
        <a href="tel:+919011955415" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@srscabservice.com" className="pc-email">
        booking@srscabservice.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-geo-alt-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Srs Cab Service</strong><br />
        Office no. 3 Mankar corner, kaspate chowk wakad Pune 411027
      </address>
    </section>
  </div>
</div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Taxiserviceinlohegaon;